import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const { BASE_API, BASE_XHH } = extractAPIValues()

// 获取消息列表
export function getMessageList (args) {
	let url = BASE_API + '/chatroom/msg/get_user_msg_list'
	return axiosGetHandler(url, args)
}

// 获取需要展示的消息通知
export function getShowNotification (args) {
  let url = BASE_API + '/chatroom/v2/msg/sys/unread'
  return axiosGetHandler(url, args)
}
// 分页获取消息列表V2
export function getMessageListByPage (args) {
	let url = BASE_API + '/chatroom/v2/msg/sys/list/page'
	return axiosGetHandler(url, args)
}

// 删除消息通知
export function delRequestMsg (args, formdata) {
	let url = BASE_API + '/chatroom/v2/msg/sys/del'
	return axiosPostHandler(url, args, formdata)
}

// 更新弹窗状态
export function updateMessageNotified (args, formdata) {
	let url = BASE_API + '/chatroom/v2/msg/notified/update'
	return axiosPostHandler(url, args, formdata)
}

// 更新消息列表全部已读
export function updateMessageRead (args, formdata) {
	let url = BASE_API + '/chatroom/v2/msg/read/update'
	return axiosPostHandler(url, args, formdata)
}

// 获取未操作消息数量（老版本使用，目前弃用）
export function getUnoperateMessageCount (args) {
	let url = BASE_API + '/chatroom/msg/user_msg_no_reply_count'
	return axiosGetHandler(url, args)
}

// 获取未读消息数量
export function getUnreadMessageCount (args) {
	let url = BASE_API + '/chatroom/v1/msg/user_msg_un_notified_count'
	return axiosGetHandler(url, args)
}

// 更新已读通知
/* 
* @param {String} msg_id 通知id
*/
export function updateMsgRead (args, formdata) {
	let url = BASE_API + '/chatroom/msg/update_notify'
	return axiosPostHandler(url, args, formdata)
}

// 发送消息
export function sendMessage (args, formdata) {
	let url = ''
  if (formdata.to_user_id) { // 私聊
	  url = BASE_API + '/chatroom/v2/msg/user'
    args.to_user_id = formdata.to_user_id
  } else if (formdata.chat_group_id) { // 群聊
    url = BASE_XHH + '/chatroom/v2/chat_group_msg/send'
  } else { // 频道聊天
	  url = BASE_API + '/chatroom/v2/channel_msg/send'
  }
  formdata.heychat_ack_id = String(formdata.heychat_ack_id)
	return axiosPostHandler(url, args, formdata)
}

// 编辑消息
export function editMessage (args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/update'
  return axiosPostHandler(url, args, formdata)
}

// 获取im私聊消息记录
export function getPrivateList (args) {
	let url = BASE_API + '/chatroom/v2/msg/user'
	return axiosGetHandler(url, args)
}

// 更新私聊im未读状态
export function updatePrivateReadState (args, formdata) {
	let url = BASE_API + '/chatroom/v2/msg/user/unread/clear'
	return axiosPostHandler(url, args, formdata)
}

// 催一催
export function urgeUser (args, formdata) {
	let url = BASE_API + '/chatroom/msg/urge_channel'
	return axiosPostHandler(url, args, formdata)
}

//获取私聊列表
export function  getPrivateChatList(args) {
  let url = BASE_API + '/chatroom/msg/get_talk_list'
  return axiosGetHandler(url, args)
}

// 获取系统消息未读
export function getOfficialChatUnread(args) {
  let url = BASE_API + '/chatroom/v1/msg/sys_notify/unread'
  return axiosGetHandler(url, args)
}

// 获取系统消息列表
export function getOfficialChatList(args) {
  let url = BASE_API + '/chatroom/v2/msg/sys_notify/list'
  return axiosGetHandler(url, args)
}
// 清空系统消息
export function clearOfficialChat(args) {
  let url = BASE_API + '/chatroom/v2/msg/sys_notify/clear'
  return axiosGetHandler(url, args)
}
//获取频道IM聊天列表
export function  getImChatList(args) {
  let url = BASE_API + '/chatroom/v2/channel_msg/list'
	return axiosGetHandler(url, args)
}

//撤回消息
export function revokeMessage(args, formdata) {
  let url = BASE_API + '/chatroom/msg/revoke'
  return axiosPostHandler(url, args, formdata)
}

//使用emoji回复消息
export function replyWithEmoji(args, formdata) {
  let url = BASE_API + '/chatroom/v1/msg/reply_emoji'
  return axiosPostHandler(url, args, formdata)
}

//获取回复了某个表情的用户列表 
export function getEmojiReplySender(args) {
  let url = BASE_API + '/chatroom/v2/channel_msg/emoji/users'
  return axiosGetHandler(url, args)
}

//系统消息状态修改
export function responseSystemNotification(args, formdata) {
  let url = BASE_API + '/chatroom/v1/msg/update_sys_msg'
  return axiosPostHandler(url, args, formdata)
}

//获取精华消息列表
// limit older(最后一条消息ID) channel_id
export function getPinnedMessageList(args) {
  let url = BASE_API + '/chatroom/v2/channel_msg/pins'
  return axiosGetHandler(url, args)
}

//设置精华消息（pin)
//msg_id channel_id
export function pinMessage(args, formdata) {
  let url = BASE_API + '/chatroom/v1/msg/pin/pin'
  return axiosPostHandler(url, args, formdata)
}

//取消设置精华消息
export function cancelPinMessage(args, formdata) {
  let url = BASE_API + '/chatroom/v1/msg/pin/cancel'
  return axiosPostHandler(url, args, formdata)
}

// 删除消息
export function deleteMessage(args, formdata) {
  let url = BASE_API + '/chatroom/v2/channel_msg/delete'
  return axiosPostHandler(url, args, formdata)
}


//获取指定频道中指定msg_id的前后若干条消息
//room_id channel_id msg_id before after after数据包括指定消息
//after = 1 -> msg_id的消息

export function getNearbyMessage(args) {
  let url = BASE_API + '/chatroom/v2/channel_msg/spot'
  return axiosGetHandler(url, args)
}

// 系统消息置顶
export function setSysNotifyTop(args, formdata) {
  let url = BASE_API + '/chatroom/v1/msg/sys_notify/set_top'
  return axiosPostHandler(url, args, formdata)
}

// 回复消息通知(修改某个消息通知的resp)
export function responseMessage(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/msg_list/resp'
  return axiosPostHandler(url, args, formdata)
}

// 搜索频道消息
export function searchChannelMessage(args) {
  let url = BASE_API + '/chatroom/v2/channel_msg/search'
  return axiosGetHandler(url, args)
}

// 创建投票
export function createVote(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/vote/create'
  return axiosPostHandler(url, args, formdata)
}

// 投票选择
export function chooseVote(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/vote/choose'
  return axiosPostHandler(url, args, formdata)
}

// 删除投票
export function deleteVote(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/vote/delete'
  return axiosPostHandler(url, args, formdata)
}

// 提前结束投票
export function terminateVote(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/vote/terminate'
  return axiosPostHandler(url, args, formdata)
}

// 自定义卡片按钮点击
export function customCardBtnClickCallback (args, formdata) {
  let url = BASE_API + '/chatroom/v2/channel_msg/card_message/button_click'
  return axiosPostHandler(url, args, formdata)
}

// 自定义卡片按钮点击(私聊)
export function customCardBtnClickCallbackPrivate (args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/card_message/button_click'
  return axiosPostHandler(url, args, formdata)
}

// 获取消息回复列表
export function getMessageReplies(args) {
  let url = BASE_API + '/chatroom/v2/channel_msg/replies'
  return axiosGetHandler(url, args)
}

// 获取指定频道最新消息
export function getChannelLastMsg (args, formdata) {
  let url = BASE_API + '/chatroom/v2/channel_msg/latest'
  return axiosPostHandler(url, args, formdata)
}

// 抽奖参与检查
export function checkLotteryParticipate(args) {
  let url = BASE_API + '/chatroom/v2/heybot/lottery/participate/check'
  return axiosGetHandler(url, args)
}

// 获取反馈消息列表
export function getFeedbackMsgList(args) {
  let url = BASE_API + '/chatroom/v2/channel_msg/by_root'
  return axiosGetHandler(url, args)
}

// 获取频道定时消息列表
export function getTimingMsgList(args) {
  let url = BASE_API + '/chatroom/v2/channel_msg/timer/list'
  return axiosGetHandler(url, args)
}

// 设置定时消息
export function sendTimingMessage (args, formdata) {
	let url = BASE_API + '/chatroom/v2/channel_msg/timer/send'
  formdata.heychat_ack_id = String(formdata.heychat_ack_id)
	return axiosPostHandler(url, args, formdata)
}

// 删除定时消息
export function deleteTimingMessage (args) {
  let url = BASE_API + '/chatroom/v2/channel_msg/timer/delete'
  return axiosGetHandler(url, args)
}

// 检查抽奖任务状态
export function checkLotteryTaskStatus(args) {
  let url = BASE_API + '/chatroom/v2/heybot/lottery/participate/check_task'
  return axiosGetHandler(url, args)
}

/**
 * 设置消息已读
 * @see https://app.apifox.com/link/project/6486200/apis/api-375164864
 * @param {Object} args 请求参数
 * @param {Object} formdata 表单数据
 * @returns {Promise} 返回Promise对象
 */
export function updateMessageSetRead(args, formdata) {
  let url = BASE_XHH + '/bbs/app/message/set_read'
  return axiosPostHandler(url, args, formdata)
}

/**
 * 隐藏消息
 * @see https://app.apifox.com/link/project/6486200/apis/api-375164845
 * @param {Object} args 请求参数
 * @param {Object} formdata 表单数据
 * @returns {Promise} 返回Promise对象
 */
export function updateMessageHide(args, formdata) {
  let url = BASE_XHH + '/bbs/app/message/hide'
  return axiosPostHandler(url, args, formdata)
}

/**
 * 设置消息置顶
 * @see https://app.apifox.com/link/project/6486200/apis/api-375164894
 * @param {Object} args 请求参数
 * @param {Object} formdata 表单数据
 * @returns {Promise} 返回Promise对象
 */
export function updateMessageSetTop(args, formdata) {
  let url = BASE_XHH + '/bbs/app/message/set_top'
  return axiosPostHandler(url, args, formdata)
}

/**
 * 删除消息
 * @see https://app.apifox.com/link/project/6486200/apis/api-376615411
 * @param {Object} args 请求参数
 * @param {Object} formdata 表单数据
 * @returns {Promise} 返回Promise对象
 */
export function updateMessageDelete(args, formdata) {
  let url = BASE_XHH + '/bbs/app/message/delete'
  return axiosPostHandler(url, args, formdata)
}

/**
 * 搜索消息
 * @see https://app.apifox.com/link/project/6486200/apis/api-378153121
 * @param {Object} args 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function searchRecentMessageList(args) {
  let url = BASE_XHH + '/bbs/app/message/search'
  return axiosGetHandler(url, args)
}